import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import request from '@/utils/httpRequest'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import './assets/css/commend.css'

Vue.config.productionTip = false
Vue.prototype.$http = request

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
